import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./js/App";
import Auth from "./js/Auth";

const root = createRoot(document.getElementById("root"));

document.title = "OLCA Dev";

root.render(
  <StrictMode>
    <Auth />
  </StrictMode>
);
